import base64 from "base-64";

export const ConfigApp = {
  Name: `Celestio`,
};

export const ConfigIntercom = {
  AppID: process.env.REACT_APP_INTERCOM_APP_ID,
};

export const token = {
  auth: base64.encode("oskar:J0nsson13"),
};

export const ConfigErrorAlert = {
  position: "top-right",
  effect: "jelly",
  timeout: 4000,
  beep: false,
  stack: 1,
};
export const ConfigSuccessAlert = {
  position: "top-right",
  effect: "jelly",
  timeout: 4000,
  beep: false,
  stack: 1,
};

export const ConfigModal = {
  width: 650,
  height: 500,
  effect: `fadeInUp`,
};
